__webpack_require__.p = "/qa/en/local-apps/ikea-self-service-tools/web/v0.1/";